<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="lessonScheduleGroup">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="teacherId">Select teacher:</label>
              <select id="teacherId" class="form-control" formControlName="teacherId">
                <option *ngFor="let teacher of teachers"
                        [value]="teacher.id"
                        [selected]="teacherId && teacher.id === teacherId">
                  {{ teacher.firstName + ' ' + teacher.lastName }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="name">Name <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
            <div class="col-md-6 mb-3">
              <label for="nameHebrew">Name Hebrew <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="nameHebrew" id="nameHebrew" placeholder="Name Hebrew">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="startDate">Start Date <sup>*</sup></label>
              <input type="date" class="form-control" formControlName="startDate" id="startDate"
                     placeholder="Start Date">
            </div>
            <div class="col-md-3 mb-3">
              <label for="endDate">End Date <sup>*</sup></label>
              <input type="date" class="form-control" formControlName="endDate" id="endDate"
                     placeholder="End Date">
            </div>
            <div class="col-md-3 mb-3">
              <label for="startTime">Start Time <sup>*</sup></label>
              <input type="time" class="form-control" formControlName="startTime" id="startTime"
                     placeholder="Start Time">
            </div>
            <div class="col-md-3 mb-3">
              <label for="endTime">End Time <sup>*</sup></label>
              <input type="time" class="form-control" formControlName="endTime" id="endTime"
                     placeholder="End Time">
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="maxStudents">Max Students <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="maxStudents" id="maxStudents"
                     placeholder="Max Students Time">
            </div>
            <div class="col-md-4 mb-3">
              <label for="minAge">Min Age <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="minAge" id="minAge"
                     placeholder="Min Age">
            </div>
            <div class="col-md-4 mb-3">
              <label for="maxAge">Max Age <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="maxAge" id="maxAge"
                     placeholder="Max Age">
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="roomId">Room</label>
              <select id="roomId" class="form-control" formControlName="roomId" [ngStyle]="getSelectedRoomStyle()">
                <option *ngFor="let room of rooms" [value]="room.id" [ngStyle]="getRoomOptionStyle(room)">
                  {{ room.name + ', ' + room.description }}
                </option>
                <option [value]="null">
                  none
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label style="width: 100%">&nbsp;</label>
              <select id="dayOfWeek" class="form-control" formControlName="dayOfWeek">
                <option *ngFor="let day of days" [value]="day">{{ day }}</option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label style="width: 100%">&nbsp;</label>
              <div class="form-check form-check-inline enabled-checkbox">
                <input class="form-check-input" type="checkbox" formControlName="isOnline" id="isOnline">
                <label class="form-check-label" for="isOnline">Online</label>
              </div>
            </div>
          </div>

          <div class="modal-buttons text-center">
            <button
              type="button"
              class="btn btn-default add-edit-button"
              (click)="closeModal(lessonScheduleGroup)"
              [disabled]="!lessonScheduleGroup.valid"
            >
              Save
            </button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
